<template>
  <v-dialog v-model="dialog" persistent max-width="600px">
    <v-card>
      <v-toolbar color="#313a46">
        <v-card-title class="text-h5 white--text">
          {{ labelBtn }} Unidade Consumidora
        </v-card-title>
      </v-toolbar>

      <v-card-text>
        <v-container>
          <v-form ref="formUc">
            <v-row>
              <v-col cols="12">
                <v-select
                  v-model="itemsForm.cnpj"
                  :items="empresas"
                  item-text="apelido"
                  item-value="cnpj"
                  label="Empresa"
                  :rules="[rules.required]"
                  required
                />
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="itemsForm.uc"
                  label="Unidade Consumidora"
                  :rules="[rules.required]"
                  required
                  type="tel"
                  @input="itemsForm.uc = itemsForm.uc.replace(/\D/g, '')"
                />
              </v-col>
            </v-row>
          </v-form>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          outlined
          class="white--text btn-form"
          color="error"
          @click="closeModal()"
        >
          FECHAR
        </v-btn>
        <v-btn
          class="white--text mr-5 btn-form"
          :color="labelBtn == 'Cadastrar' ? '#313a46' : 'warning'"
          @click="createUnidadeConsumidora()"
        >
          {{ labelBtn }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import toast from "@/commom/toast";
import unidadesConsumidoras from "@/services/http/rpa/UnidadesConsumidoras";
import empresaFilial from "../../../../services/http/rpa/EmpresaFilial";
export default {
  props: {
    labelBtn: {
      type: String,
    },
    dialog: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    itemsForm: {
      uc: "",
      cnpj: "",
    },
    empresas: [],
    rules: {
      required: (value) => !!value || "Campo obrigatório.",
    },
  }),
  created() {
    this.fetchEmpresas();
  },
  methods: {
    async closeModal() {
      this.$emit("update:dialog", false);
      this.$refs.formUc.reset();
    },
    async fetchEmpresas() {
      try {
        const response = await empresaFilial().list({
          per_page: -1
        });
        this.empresas = response.data.data;
      } catch (err) {
        toast("error", "Erro ao carregar empresas");
      }
    },
    async createUnidadeConsumidora() {
      if (!this.$refs.formUc.validate()) return;
      try {
        console.log(this.itemsForm.uc, this.itemsForm.cnpj);
        await unidadesConsumidoras().store(this.itemsForm);
        this.closeModal();
        toast("success", "Unidade Consumidora Cadastrada cadastrado!");
      } catch (err) {
        toast("error", "Erro inesperado");
      }
      console.log(this.$parent);
      this.$parent.fetchUnidadesConsumidoras();
    },
  },
};
</script>
